export class FormioToken {
  public static readonly tokenNameInStorage = 'formioToken';
  public static readonly scheme = 'Bearer ';
}
